import { Component } from '@opten/compiler/metadata/component';

import { debounce } from '@opten/reactive/debounce';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';

@Component({ className: 'js-countdown' })

export class CountdownComponent {
	private now: number;
	private countdownDate: number;
	private interval: number;

	private distance: number;
	private days: number;
	private hours: number;
	private minutes: number;
	private seconds: number;

	private dayWrapper: HTMLElement;
	private hoursWrapper: HTMLElement;
	private minutesWrapper: HTMLElement;
	private secondsWrapper: HTMLElement;

	private resultWrapper: HTMLElement;
	private wrapper: HTMLElement;


	constructor(private element: HTMLElement) {

		this.dayWrapper = this.element.querySelector('.js-countdown-days');
		this.hoursWrapper = this.element.querySelector('.js-countdown-hours');
		this.minutesWrapper = this.element.querySelector('.js-countdown-minutes');
		this.secondsWrapper = this.element.querySelector('.js-countdown-seconds');

		this.resultWrapper = this.element.querySelector('.js-countdown-result');
		this.wrapper = this.element.querySelector('.js-countdown-wrapper');

		this.now = new Date().getTime();
		this.countdownDate = new Date(this.element.getAttribute('data-countdown')).getTime();

		const hideNav = this.element.getAttribute('data-hide-nav');
		if(hideNav === 'True'){
			const header = document.querySelector('.js-nav');
			const footer = document.querySelector('footer');

			addClass(header, 'd-none');
			addClass(footer, 'd-none');
		}


		if(this.countdownDate > 0 && this.countdownDate > this.now){
			this.interval = setInterval(() => this.countdown(), 1000);
		} else {
			this.countdownEnd();
		}
	}

	private countdown() {
		this.now = new Date().getTime();
		this.distance = this.countdownDate - this.now;
		this.days = Math.floor(this.distance / (1000 * 60 * 60 * 24));
		this.hours = Math.floor((this.distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		this.minutes = Math.floor((this.distance % (1000 * 60 * 60)) / (1000 * 60));
		this.seconds = Math.floor((this.distance % (1000 * 60)) / 1000);

		this.dayWrapper.innerHTML = this.days.toString();
		this.hoursWrapper.innerHTML = this.hours.toString();
		this.minutesWrapper.innerHTML = this.minutes.toString();
		this.secondsWrapper.innerHTML = this.seconds.toString();

		if (this.distance < 0) {
			clearInterval(this.interval);
			this.countdownEnd();
		}
	}




	private countdownEnd(){
		// tslint:disable-next-line: no-inner-html
		addClass(this.wrapper, 'd-none');
		removeClass(this.resultWrapper, 'd-none');
	}
}
